import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  // Converts the model to mm/dd/yyyy format
  format(date: NgbDateStruct | null): string {
    if (!date) return '';
    const mm = date.month.toString().padStart(2, '0');
    const dd = date.day.toString().padStart(2, '0');
    const yyyy = date.year;
    return `${mm}/${dd}/${yyyy}`;
  }

  // Parses mm/dd/yyyy input to NgbDateStruct
  parse(value: string): NgbDateStruct | null {
    if (!value) return null;
    const parts = value.split('/').map((part) => parseInt(part, 10));
    if (parts.length === 3 && parts[0] > 0 && parts[1] > 0 && parts[2] > 0) {
      return { month: parts[0], day: parts[1], year: parts[2] };
    }
    return null;
  }
}